<template>
  <span>
    <div class="row">
      <div class="col-md-4">
        <label class="col-form-label">Port Name</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.port_name"
            class="form-control"
            autocomplete="off"
            placeholder="Port Name"
          />
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Country</label>
        <div class="col-sm-12">
          <my-select
            disableFormControl="true"
            :selection.sync="form.country_id"
            :suggestions="countries"
            placeholder="Select country"
          ></my-select>
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Latitude</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.latitude"
            class="form-control"
            placeholder="Latitude"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label class="col-form-label">Longitude</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.longitude"
            class="form-control"
            placeholder="Longitude"
          />
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Timezone</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.timezone"
            class="form-control"
            placeholder="Timezone"
          />
        </div>
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "OrganizationFormWidget",
  props: ["form"],
  data() {
    return {
      countries: [],
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("ports/masters");
      masters = masters.data;
      masters.countries.forEach((country) => {
        this.countries.push({
          id: country.id,
          name: country.name,
        });
      });
    },
  },
};
</script>
